export const TOOLKIT_VERSION = 1 as const;

export type Json = null | boolean | number | string | Json[] | { [key: string]: Json };

export type Verdict = { correct: boolean; rewarded: number };

export type Prefs = {
  reduceMotion: boolean;
  transitionType: string;
  transitionMs: number;
  promptRepeatSeconds: number;
  promptRepeatMinSeconds: number;
  language: string;
};

export type Toolkit = {
  version: typeof TOOLKIT_VERSION;
  kind: string;
  live: boolean;
  content: Readonly<Record<string, unknown>>;
  prefs: Readonly<Prefs>;
  speech: {
    say(text: string): void;
    stop(): void;
  };
  sound: {
    correct(): void;
  };
  trials: {
    register(presented: Record<string, unknown>, answer: Record<string, unknown> | null): Promise<string | null>;
    respond(trialId: string, response: string): Promise<Verdict | null>;
  };
  rounds: {
    available: boolean;
    start(): Promise<Record<string, unknown> | null>;
    attempt(roundId: string, body: Record<string, unknown>): Promise<Record<string, unknown> | null>;
  };
  session: {
    status(state: 'playing' | 'empty'): void;
    offerBreak(on: boolean | null): void;
    current(trialId: string | null): void;
    takeBreak(): void;
    onResume(fn: () => void): () => void;
    fail(message: string): void;
  };
  clock: {
    now(): number;
    elapsedSince(start: number): number;
    paused(): boolean;
    onPauseChange(fn: (paused: boolean) => void): () => void;
  };
  media: {
    picture(text: string): string | undefined;
    onChange(fn: () => void): () => void;
  };
  store: {
    get(key: string): Json | undefined;
    set(key: string, value: Json): void;
  };
  t(text: string, vars?: Record<string, string | number>): string;
};

export type Mounted = { unmount(): void };

export type GameModule = {
  toolkit: typeof TOOLKIT_VERSION;
  mount(el: HTMLElement, kit: Toolkit): Mounted;
};
